import {FC, useState} from 'react'
import {useAuth} from '../../../app/modules/auth'
import {resendVerificationEmail} from '../../../app/modules/auth/core/_requests'
import './EmailVerificationNotice.css'

const DISMISS_KEY = 'tr_email_verification_notice_dismissed'

function readDismissed(): boolean {
  try {
    return window.sessionStorage.getItem(DISMISS_KEY) === '1'
  } catch {
    return false
  }
}

// Quem entra pelo cadastro mínimo usa o app sem confirmar o e-mail por 15 dias; depois, o login exige
// a confirmação. O aviso fica no topo do conteúdo até confirmar (dá para fechar nesta sessão).
export const EmailVerificationNotice: FC = () => {
  const {currentUser} = useAuth()
  const [dismissed, setDismissed] = useState(readDismissed)
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')

  if (!currentUser || currentUser.email_verified !== false || dismissed) return null

  const deadline = currentUser.email_verification_deadline
    ? new Date(currentUser.email_verification_deadline).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      })
    : null

  const resend = async () => {
    setStatus('sending')
    try {
      await resendVerificationEmail(currentUser.email)
      setStatus('sent')
    } catch {
      setStatus('error')
    }
  }

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // Sem sessionStorage o aviso só some até recarregar.
    }
    setDismissed(true)
  }

  return (
    <div className='email-verification-notice' role='status'>
      <i className='bi bi-envelope-check text-brand fs-3 me-3 flex-shrink-0'></i>
      <div className='flex-grow-1 fs-7 text-gray-800'>
        <span className='fw-bold'>Confirme seu e-mail.</span> Enviamos um link para{' '}
        <span className='fw-semibold'>{currentUser.email}</span>.
        {deadline && <> A partir de {deadline}, o login passa a pedir a confirmação.</>}
        {status === 'sent' && <span className='ms-1 text-success'>E-mail reenviado.</span>}
        {status === 'error' && (
          <span className='ms-1 text-danger'>
            Não foi possível reenviar agora. Tente em alguns minutos.
          </span>
        )}
      </div>
      <div className='d-flex align-items-center gap-2 ms-3 flex-shrink-0'>
        {status !== 'sent' && (
          <button
            type='button'
            className='btn btn-sm btn-light'
            onClick={resend}
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Enviando...' : 'Reenviar e-mail'}
          </button>
        )}
        <button
          type='button'
          className='btn btn-sm btn-icon btn-active-light'
          onClick={dismiss}
          aria-label='Fechar aviso'
        >
          <i className='bi bi-x-lg'></i>
        </button>
      </div>
    </div>
  )
}
